<script setup>
import Pagination from "@/Components/Pagination.vue";
import Item from "@/Pages/Product/Partials/Item.vue";
import Grid from "@/Components/Grid.vue";

defineProps({
    products: Object, // Pagination
    gridSize: Number,
});
</script>

<template>
    <Grid :grid-size="gridSize">
        <Item v-for="product in products.data" :key="product.id" :product="product"/>
    </Grid>
    <Pagination class="pt-10" :pagination="products"/>
</template>
